export default class ScoreCalculator {

    constructor(categories, participantRoles) {
        this.allCategories = categories;
        this.allParticipantRoles = participantRoles;
    }

    checkForNaObservations(indicator, observations, participantId = null) {
        for (const observation of observations) {
            if (observation.na) {
                if (indicator.teamBased) {
                    return true
                } else {
                    if (!observation.participantId) {
                        return true
                    } else if (participantId && observation.participantId === participantId) {
                        return true
                    }
                }
            }
        }
        return false
    }

    getIndicatorRoles(evaluation, indicator) {
        var roles = []
        for (const roleId of indicator.roleIdsList) {
            var found = this.allParticipantRoles && this.allParticipantRoles.nodes.find(role => role.id === roleId)
            if (found) {
                evaluation.participationsByEvaluationId.nodes.forEach(node => {
                    if ((node.participantRoleByRoleId && node.participantRoleByRoleId.id === roleId) || (node.roleId === roleId)) {
                        roles.push(found)
                    }
                })
            }
        }
        return roles
    }

    calculateScore(evaluation, template) {
        const counterTemplate = { score: 0, max: 0, hasMissing: false, zooz: true }
        const evaluationScore = {
            ...counterTemplate,
            critical: { ...counterTemplate },
            important: { ...counterTemplate },
            byCategory: {},
        }
        if (!evaluation) return evaluationScore
        if (evaluation.templateId && template && template.id != evaluation.templateId) throw "Evaluation is not from specified template"
        if (!template) template = evaluation.templateByTemplateId

        const observations = evaluation.observationsByEvaluationId.nodes
        const participations = evaluation.participationsByEvaluationId.nodes
        const byCategory = evaluationScore.byCategory

        const rows = template.templateRowsByTemplateId.nodes
        for (const row of rows) {
            const indicator = Object.assign({}, row.indicatorByIndicatorId)
            const level = indicator.score === 10 ? 'critical' : 'important'

            // Count scores in several "counters" - total, total by level (critical/important), by category
            const counters = [ evaluationScore, evaluationScore[level] ]

            // Build a map of scores by category and the contributing indicators
            const categoryIds = indicator.indicatorCategoriesByIndicatorIdList.map(ic => ic.categoryId)
            for (const categoryId of categoryIds) {
                if (!byCategory[categoryId]) {
                    byCategory[categoryId] = {
                        ...counterTemplate,
                        critical: { ...counterTemplate },
                        important: { ...counterTemplate },
                        indicators: [],
                    }
                }
                if (!byCategory[categoryId].indicators.includes(indicator)) {
                    byCategory[categoryId].indicators.push(indicator)
                }
                counters.push(byCategory[categoryId])
                counters.push(byCategory[categoryId][level])
            }

            var isNa = false
            const indicatorObservations = observations.filter(obs => obs.indicatorId === indicator.id)
            var roles = this.getIndicatorRoles(evaluation, indicator)
            if (indicator.teamBased) {
                // Team based = inte individuellt per roll
                var observed = false
                if (indicatorObservations.length > 0) {
                    isNa = this.checkForNaObservations(indicator, indicatorObservations, null)
                    if (!isNa) {
                        observed = true;
                    }
                }
                if (!isNa) {
                    if (observed) {
                        for (const counter of counters) counter.score += indicator.score
                    }
                    for (const counter of counters) counter.max += indicator.score
                    for (const counter of counters) counter.isNa = false
                }
                if (!observed && !isNa) {
                    for (const counter of counters) counter.hasMissing = true
                }
                indicator.observed = observed
            } else {
                // Fiska fram observationer per roll när PI:s är individuella
                var participation
                const isNaPerRole = {}
                const observedPerRole = {}
                var countNaPerRole = 0
                for (const role of roles) {
                    participation = participations.find(part => part.participantRoleByRoleId ? part.participantRoleByRoleId.id === role.id : part.roleId === role.id)
                    isNaPerRole[role.id] = this.checkForNaObservations(indicator, indicatorObservations, participation.participantByParticipantId ? participation.participantByParticipantId.id : participation.participantId)
                    if (!isNaPerRole[role.id]) {
                        if (indicatorObservations.find(observation => participation.participantByParticipantId ? observation.participantId === participation.participantByParticipantId.id : observation.participantId === participation.participantId)) {
                            observedPerRole[role.id] = true;
                        }
                        if (observedPerRole[role.id]) {
                            for (const counter of counters) counter.score += indicator.score
                        }
                        for (const counter of counters) counter.max += indicator.score
                        for (const counter of counters) counter.isNa = false
                    } else {
                        countNaPerRole++
                    }
                    if (!observedPerRole[role.id] && !isNaPerRole[role.id]) {
                        for (const counter of counters) counter.hasMissing = true
                    }
                }
                indicator.observedPerRole = observedPerRole
                indicator.isNaPerRole = isNaPerRole
                if (countNaPerRole >= roles.length) isNa = true
            }
            indicator.roles = roles
            indicator.isNa = isNa
            if (!isNa) {
                for (const counter of counters) counter.zooz = false
            } else {
                for (const counter of counters) if (!('isNa' in counter)) counter.isNa = true
            }
        }

        return evaluationScore
    }

    calculateTrend(evaluations, template) {
        
        function contribute(scoreCounter, trendCounter) {
            if (scoreCounter.max === 0) return
            const percent = Math.round(scoreCounter.score / scoreCounter.max * 100)
            if (percent < trendCounter.min) trendCounter.min = percent
            if (percent > trendCounter.max) trendCounter.max = percent
            trendCounter.sum += percent
            trendCounter.count++
        }
        
        const scores = []
        for (var evaluation of evaluations) {
            scores.push(this.calculateScore(evaluation, template))
        }
        const trendTemplate = { min: 100, max: 0, sum: 0, count: 0 }
        const trend = {
            ...trendTemplate,
            critical: { ...trendTemplate },
            important: { ...trendTemplate },
            byCategory: {}
        }
        for (const score of scores) {
            contribute(score, trend)
            contribute(score.critical, trend.critical)
            contribute(score.important, trend.important)
            for (const catId in score.byCategory) {
                const scorecat = score.byCategory[catId]
                var trendcat = trend.byCategory[catId]
                if (!trendcat) {
                    trendcat = {
                        ...trendTemplate,
                        critical: { ...trendTemplate },
                        important: { ...trendTemplate },
                    }
                    trend.byCategory[catId] = trendcat
                }
                contribute(scorecat, trendcat)
                contribute(scorecat.critical, trendcat.critical)
                contribute(scorecat.important, trendcat.important)
            }
        }
        const counters = [trend, trend.critical, trend.important]
        for (const catId in trend.byCategory) {
            const cat = trend.byCategory[catId]
            counters.push(cat)
            counters.push(cat.critical)
            counters.push(cat.important)
        }
        for (const trendCounter of counters) {
            if (trendCounter.count > 0) {
                trendCounter.average = Math.round(trendCounter.sum / trendCounter.count)
            }
        }
        return trend
    }
}
